<template>
    <div>
        <CRow>
            <CCol md="12">
                <CForm>

                    <CCard id="printMe">
                        <CCardHeader>
                            <CRow>

                                <CCol sm="4" md="4" style="text-align: right">
                                    <strong style="text-align: right;top: 35%;position: absolute;">{{selectedTypeTitle}}
                                      {{ $t('components.number') }}: {{doc_id}}</strong>

                                </CCol>
                                <CCol sm="4" md="4">
                                    <h2>{{ VUE_APP_NAME }}</h2>

                                </CCol>
                                <CCol sm="4" md="4" style="text-align: left">
                                    <CImg :src="get_logo()" width="100px" height="50px"/>

                                </CCol>
                            </CRow>

                        </CCardHeader>
                        <CCardBody>
                          <CRow>
                            <CCol sm="4" md="4">
                                <strong>{{selectedTypeLabel}} : {{document_person}}({{tablo}}) {{partyMobile}}</strong>

                            </CCol>
                              <CCol sm="4" md="4" class="text-center">
                                  <strong>{{selectedTypeLabelRevert}} : {{this.$root.company_name}}</strong>

                              </CCol>

                              <CCol sm="4" md="4" class="text-left">
                                  <strong>{{ $t('components.visitor') }} : {{document_visitor}} {{vMobile}}</strong>

                              </CCol>
                          </CRow>
                            <hr class="mt-0">

                            <CRow>

                                <CCol sm="4" md="4">
                                    <div>
                                        <strong>{{ $t('components.date') }} : {{date}}</strong>
                                    </div>
                                </CCol>

                                <CCol sm="4" md="4" class="text-center">
                                    <strong >{{ $t('components.warehouse') }}: {{selected_place}}</strong>

                                </CCol>

                                <CCol sm="4" md="4" class="text-left">
                                    <strong >{{ $t('components.driver') }}: {{document_driver}} {{tozikonandeMobile}}</strong>

                                </CCol>
                            </CRow>
                            <hr class="mt-0">

                            <p v-if="document_summary!=null">{{ $t('components.factorSummary') }}: {{document_summary}} </p>
                            <hr v-if="document_summary!=null" class="mt-0">

                            <CCardHeader style="text-align: right">
                                <strong>{{ $t('components.documentProducts') }}</strong>
                            </CCardHeader>


                            <CDataTable
                                    :items="product_items"
                                    :fields="fields"

                                    :items-per-page="200"
                                    hover
                                    pagination
                            >
                                <template #row="{item}">

                                    <td>
                                        <strong >{{item.row_id+1}}</strong>

                                    </td>

                                </template>
                                <template #name="{item}">

                                    <td>
                                        <strong >{{item.productName}}</strong>

                                    </td>

                                </template>

                                <template #unit="{item}">

                                    <td>
                                        <strong >{{item.productUnitName}}</strong>

                                    </td>

                                </template>

                                <template #qty="{item}">

                                    <td>
                                        <strong >{{Math.abs(item.qty)}}</strong>

                                    </td>

                                </template>
                                <template #price="{item}">

                                    <td>
                                        <strong >{{item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g,
                                            ",")}} </strong>

                                    </td>

                                </template>
                                <template #totalPrice="{item}">

                                    <td>
                                        <strong >{{item.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g,
                                            ",")}} </strong>

                                    </td>

                                </template>
                                <template #summary="{item}">

                                    <td>
                                        <strong >{{item.docDesc}}</strong>

                                    </td>

                                </template>


                            </CDataTable>
                            <hr class="mt-0">

                          <CRow >
                            <CCol col="4"></CCol>
                            <CCol col="4"></CCol>
                            <CCol col="4">
                              <CDataTable
                                  :items="document_result_price"
                                  :fields="fields_total_price"
                                  striped
                                  border
                                  :items-per-page="200"
                                  hover
                                  pagination
                              >
                                <template #resultTitle="{item}">

                                  <td>
                                    <strong >{{ item.resultTitle }}</strong>

                                  </td>


                                </template>
                                <template #resultPrice="{item}">

                                  <td>
                                    <strong >{{ item.resultPrice }}</strong>
                                    <strong > {{VUE_APP_Currency}}</strong>

                                  </td>

                                </template>

                              </CDataTable>

                            </CCol>
                          </CRow>
                            <CRow>

                                <CCol sm="12" md="12">
                                    <strong>{{$t('components.documentTotalPrice')}} {{total_price}} {{VUE_APP_Currency }}</strong>


                                </CCol>

                            </CRow>
                        </CCardBody>
                        <CCardFooter>

                            <strong v-if="address!= 'undefined'">{{$t('components.address')}} : {{address}}</strong>

                        </CCardFooter>
                    </CCard>

                    <CCol sm="6" md="4">
                        <CButton  @click="print()" size="sm"
                                 color="primary">
                            <CIcon name="cil-check-circle"/>
                            {{$t('buttons.print')}}
                        </CButton>
                    </CCol>
                    <CCol sm="6" md="4">


                    </CCol>

                </CForm>

            </CCol>
        </CRow>
        <CRow>

        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Vue from 'vue';
    import VueHtmlToPaper from 'vue-html-to-paper';

    const options = {
        name: '_blank',
        specs: [
            'fullscreen=yes',
            'titlebar=yes',
            'scrollbars=yes',
        ],
        styles: [
            'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
            'https://unpkg.com/kidlat-css/css/kidlat.css',

        ]
    }

    Vue.use(VueHtmlToPaper, options);
    var items_data = [];




    export default {

        name: 'Login',
        data() {
            return {
              VUE_APP_Currency:localStorage.getItem('currency'),
              VUE_APP_NAME:localStorage.getItem('app_name'),

              doc_id:0,
                date: '',
                product_items: items_data.map((item, row_id) => {
                    return {...item, row_id}
                }),
                fields : [
                    {key: 'row',label:this.$t('tables.row'), _style: 'width:3%;padding:0px'},
                    {key: 'name',label:this.$t('tables.name'), _style: 'padding:0px'},
                    {key: 'unit',label:this.$t('tables.unit'), _style: 'padding:0px'},
                    {key: 'qty',label:this.$t('tables.qty'), _style: 'padding:0px'},
                    {key: 'price',label:this.$t('tables.price'), _style: 'padding:0px'},
                    {key: 'totalPrice',label:this.$t('tables.totalPrice'), _style: 'padding:0px'},
                    {key: 'summary',label:this.$t('tables.summary'), _style: 'padding:0px'},


                ],
              fields_total_price: [
                {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
                {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},

              ],
                selectedTypeQty: 1,
                selectedTypeLabel: this.$t('components.seller'),
                selectedTypeLabelRevert: this.$t('buttons.buyer'),
                selectedTypeTitle:this.$t('components.documentBuy'),
                selectedType: 1,

                tablo: '',
                address: '',

                document_person: '',
                document_summary: '',
                document_visitor: '',
                document_driver: '',

                vMobile:'',
                partyMobile:'',
                tozikonandeMobile:'',

                product_name: '',
                product_count: '',
                product_unit: '',
                product_summary: '',
                product_price: '',
                product_off: 0,
                product_tax: 0,

                unit_items: [],
                doc_status : 0,
                total_price: 0,
                details: [],
                permission_group_items: [],
                selected_permission_group: 0,

                places_items: [],
                unit_items_filtered: [],
                selected_place: '',
                selected_product: null,

                status_form: 0,
                master_id: 0,
              document_result_price: [],

            }
        }, mounted() {


            bus.$on('print_confirm', (data) => {
                // alert(data);
               this.doc_id = data;

            });
        },
        created() {

        },
        watch: {
            '$route.params.cat_id': function () {
                this.get_lists();
            },
            'doc_id': function () {
                this.$root.root_validate_errors = [];

                this.get_product_units();


                },
            'product_items': function () {
                this.total_price = 0;
                var off = 0;
                var tax = 0;
                var unit_value=1;
                this.total_price = 0;
                this.product_items.forEach((val) => {
                    this.unit_items.forEach((val_unit) => {
                        if(val_unit.id == val.productUnitId){
                            unit_value = val_unit.value;
                        }

                    });
                    val.total_price = (Math.abs(val.qty) * val.price * unit_value);
                    this.total_price += (Math.abs(val.qty) * val.price * unit_value);

                });
                off = this.product_off;
                tax = this.product_tax;
                var off_price = (this.total_price * off) / 100;
                var tax_price = (this.total_price * tax) / 100;
                this.total_price = this.total_price - off_price - tax_price;
                this.total_price = this.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            'selectedType': function () {
                if (this.selectedType == 1) {

                      this.selectedTypeLabel = this.$t('components.seller');
                    this.selectedTypeLabelRevert = this.$t('components.buyer');
                    this.selectedTypeQty = 1;
                    this.selectedTypeTitle= this.$t('components.documentBuy');
                }
                if (this.selectedType == 3) {
                    this.selectedTypeLabel = this.$t('components.buyer');
                    this.selectedTypeLabelRevert = this.$t('components.seller');
                    this.selectedTypeQty = -1;
                    this.selectedTypeTitle= this.$t('components.documentSell');

                }
                if (this.selectedType == 5) {
                    this.selectedTypeLabel = this.$t('components.employee');
                    this.selectedTypeLabelRevert = this.$t('components.company');
                    this.selectedTypeQty = 1;
                    this.selectedTypeTitle= this.$t('components.documentFirst');

                }
            },
        },
        methods: {
            finalize() {
                var self = this;


                const formData = new FormData();

                var url = "AddFactorToFinal";

                formData.append("id", this.doc_id);

                axios.post(url, formData, {
                }).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        self.get_document_master();

                    } else {
                        // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            get_product_units() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetProductUnits', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.unit_items = content_data.data;
                        self.get_document_master();

                      self.get_document_result();

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            print() {
                // Pass the element id here
                this.$htmlToPaper('printMe');
            },
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            get_document_master() {
                var self = this;


                const formData = new FormData();

                var url = "GetRecById";

                formData.append("id",  this.doc_id);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
                        self.selectedType = content_data.data.docType;
                        self.document_person = content_data.data.partyName;
                        self.date = content_data.data.docDate.replace("-","/").replace("-","/");
                        self.selected_place = content_data.data.placeName;
                        self.document_summary = content_data.data.docDesc;
                        self.document_visitor = content_data.data.createdBy;
                        self.document_driver = content_data.data.toziKonande;
                        self.doc_status = content_data.data.statusId;
                        self.tablo = content_data.data.tablo;
                        self.address = content_data.data.addressText;
                        self.vMobile=content_data.data.vMobile;
                            self.partyMobile=content_data.data.partyMobile;
                            self.tozikonandeMobile = content_data.data.tozikonandeMobile;
                        self.get_document_details();

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
          get_document_result() {
            var self = this;


            const formData = new FormData();

            var url = "GetFactorResultByMasterId";

            formData.append("Id", this.doc_id);

            axios.post(url, formData, {}).then(function (response) {

              var content_data = response.data;

              // items = content_cats.orders;
              if (content_data.statusCode == 0) {
                self.document_result_price = content_data.data;

              } else {
                self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

              }

            })
                .catch(function (error) {

                  console.log(error);
                });

          },

          get_document_details() {
                var self = this;


                const formData = new FormData();

                var url = "GetDocItemsByDocId";

                formData.append("id",  this.doc_id);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.product_items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}

                        });
                        setTimeout(function () {
                            self.print()
                        }, 1000);

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },


        }
    }

</script>
